import { render, staticRenderFns } from "./SearchFacets.vue?vue&type=template&id=0a38d1c9"
import script from "./SearchFacets.vue?vue&type=script&lang=js"
export * from "./SearchFacets.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports